import { TemplateElement, html, defineElement, unsafeHTML, when, classMap } from '@webtides/element-js';
import style from './content-card.css';
import '../button/button.js';
import '../icon/icon.js';

/**
 * @property {'' || 'green-light25'} backgroundColor
 * @property {string} icon
 * @property {string} headline
 * @property {string} text
 * @property {LinkProperties} link
 */
export default class ContentCard extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            backgroundColor: '',
            icon: '',
            headline: '',
            text: '',
            link: null,
        };
    }

    get buttonVariant() {
        return this.backgroundColor === 'green-light25' ? 'secondary' : 'tertiary';
    }

    template() {
        const bgClasses = {
            'bg-green-light25': this.backgroundColor === 'green-light25' || this.backgroundColor === '',
            'bg-[white]': this.backgroundColor === 'white',
        };
        return html`
            <div data-surface="light" class="h-full rounded-2xl p-fix-m flex flex-col gap-fix-s ${classMap(bgClasses)}">
                ${when(
                    this.icon,
                    html` <mb-icon size="inherit" name="${this.icon}" class="size-32 lg:size-48"></mb-icon> `,
                )}
                ${when(this.headline, html` <h3 class="fix-title3-medium mb-0">${this.headline}</h3> `)}
                ${when(this.text, html` <div class="text-base text-green-light mb-0">${unsafeHTML(this.text)}</div> `)}
                ${when(
                    this.link?.url && this.link.text,
                    html`
                        <mb-button
                            href="${this.link?.url}"
                            variant="${this.buttonVariant}"
                            class="mt-auto"
                            element="content card"
                        >
                            ${this.link?.text}
                            <mb-icon slot="suffix" name="app--cta-arrow-right" class="size-12"></mb-icon>
                        </mb-button>
                    `,
                )}
            </div>
        `;
    }
}

defineElement('mb-content-card', ContentCard);
